import { Box } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useEffect, useState, Fragment } from "react";
import { Loading } from "../../components/loading/Loading";
import Search from "../../components/search/Search";
import SimpleList from "../../components/simple-list/SimpleList";
import InfiniteLoadingList from "../../components/infinite-loading-list/InfiniteLoadingList";
import { useTranslation } from "react-i18next";
import DropdownSelect from "../../components/dropdown-select/DropdownSelect";

function GenericPicker(props) {

    const [t, i18n] = useTranslation()
    const [loading, setLoading] = useState(false)
    const [originalData, setOriginalData] = useState([])
    const [searchedData, setSearchedData] = useState([])
    const [newData, setNewData] = useState(false)
    const [filter, setFilter] = useState("")

    const searchBarHeight = 4;
    const filterBarHeight = props.filterFunction != null ? 4 : 0;
    const idField = props.idField || "id"
    const valueField = props.valueField || ""

    useEffect(() => {
        if (!props.infiniteLoading) {
            retrieveData()
        }
    }, [])

    useEffect(() => {
        const fileValues = props.data;
        const data = createData(fileValues)

        setSearchedData(data)
        setOriginalData(data)
    }, [newData, filter])

    function createData(inputData, useSearch = false) {
        const data = []
        const selected = props.selected ? props.selected : [];
        inputData.forEach(value => {

            var filterFlag = false
            // check if filter is being used, check value matches filter, otherwise ignore
            if (props.filterFunction != null && filter != "") {
                filterFlag = props.filterFunction(value, filter)
            } else {
                filterFlag = true
            }

            // check filter is used, that the item is not already selected and that the filterFlag was true
            if (useSearch || (!selected.includes(value[idField]) && filterFlag)) {
                if ((props.valueField != null || props.secondaryValueField != null)) {
                    data.push({
                        id: value[props.idField],
                        value: value[props.valueField] != null ? value[props.valueField] : value[props.secondaryValueField]
                    });
                } else {
                    data.push({
                        id: value,
                        value: value
                    });
                }
            }
        });
        return data
    }

    function handleSelection(selection) {
        props.handleSelection(selection);
    }

    function retrieveData() {
        setLoading(true)

        props.getAllData(() => {
            setLoading(false)
            setNewData(true)
        });
    }

    /**
     * Set the data filter
     * @param {Object[]} data The filter value to set 
     */
    function handleFilterChange(data) {
        setFilter(data)
    }

    return (
        // Calculated height by removing size of search bar and filter bar (if visible)
        <Box style={{ height: `calc(100% - ${searchBarHeight}em - ${filterBarHeight}em)` }}>

            <Fragment>
                {
                    props.filterFunction != null ?
                        <DropdownSelect
                            label={props.filterLabel}
                            value={filter}
                            data={props.filterData}
                            handleChange={handleFilterChange}
                        />
                        : null
                }
                <Search
                    loading={loading}
                    searchField={props.searchField != null ? props.searchField : "value"}
                    secondaryFields={props.secondaryFields}
                    returnSearchMatches={data => {
                        setSearchedData(data)
                    }}
                    data={originalData}
                    searchTitle={t('picker.search-searchtitle', { searchTitle: props.searchTitle })}
                    searchFunction={props.loadNextPage}
                />
                {
                    loading ?
                        <Loading /> :
                        props.infiniteLoading ?
                            <InfiniteLoadingList
                                currentSelection={props.currentSelection}
                                handleSelection={handleSelection}
                                emptyPlaceholder={t('picker.no-ids', { searchTitle: props.searchTitle })}
                                hasNextPage={props.hasNextPage}
                                isNextPageLoading={props.isNextPageLoading}
                                items={createData(props.data, true)}
                                loadNextPage={props.loadNextPage}
                                minimumBatchSize={1}
                                threshold={3}
                            /> :
                            <SimpleList
                                emptyPlaceholder={t('picker.no-ids', { searchTitle: props.searchTitle })}
                                handleSelection={handleSelection}
                                data={searchedData}
                                currentSelection={props.currentSelection}
                                singleSelection={props.singleSelection}
                            />
                }
            </Fragment>
        </Box>
    );
}

GenericPicker.propTypes = {
    selected: PropTypes.arrayOf(PropTypes.string),
    handleSelection: PropTypes.func.isRequired,
    searchTitle: PropTypes.string.isRequired,
    searchField: PropTypes.string,
    getAllData: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    idField: PropTypes.string.isRequired,
    valueField: PropTypes.string.isRequired,
    secondaryValueField: PropTypes.string,
    currentSelection: PropTypes.arrayOf(PropTypes.string).isRequired,
    secondaryFields: PropTypes.arrayOf(PropTypes.string),
    filterFunction: PropTypes.func,
    filterData: PropTypes.array,
    filterLabel: PropTypes.string,
    singleSelection: PropTypes.bool
}

export default GenericPicker